module.exports = __webpack_public_path__ + "img/eye.68832d53.svg";